export default "__VITE_ASSET__b634b9df__"